export const dispatchToast = payload => ({
    type: 'SEND_TOAST',
    state: payload[0],
    payload: payload[1],
    options: payload[2]
});
